<div class="loader-circles" [ngClass]="{'loader-circles--light': isLight}">
  <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
</div>